import React from 'react';
import MenuUniformesDirector from './MenuUniformesDirector';
import MenuUniformesTienda from './MenuUniformesTienda';
import MenuUniformesPublico from './MenuUniformesPublico';
import MenuUniformesCanaco from './MenuUniformesCanaco';
import MenuUniformesSec from './MenuUniformesSec';
import MenuUniformesTallas from './MenuUniformesTallas';
import MenuUniformesCancelarEntrega from './MenuUniformesCancelarEntrega';
import MenuUniformesValidacion from './MenuUniformesValidacion';
import MenuTabletsAlmacen from './MenuTabletsAlmacen';
import MenuTabletsDirector from './MenuTabletsDirector';
import MenuUniformesTiendaMulti from './MenuUniformesTiendaMulti';
import { storage } from '../../helpers/storage';


const Menu = ({link}) => {

    let perfil =  storage.get('perfilid');



    return (
        <>
            {(perfil == 1 ? <MenuUniformesDirector link={link} />
            :([2, 13].includes(perfil) ? <MenuUniformesTienda link={link} />
            :([3, 19, 20, 21].includes(perfil) ? <MenuUniformesPublico link={link} />
            :(perfil == 4 ? <MenuUniformesPublico link={link} />
            :(perfil == 5 ? <MenuUniformesSec link={link} />
            :(perfil == 6 ? <MenuUniformesTallas link={link} />
            :(perfil == 7 ? <MenuUniformesCancelarEntrega link={link} />
            :([9, 10, 11, 12].includes(perfil) ? <MenuUniformesValidacion link={link} />
            :([14, 15].includes(perfil) ? <MenuTabletsAlmacen link={link} />
            :([17].includes(perfil) ? <MenuUniformesTiendaMulti link={link} />
            :(perfil === 16 ? <MenuTabletsDirector link={link} /> :"")))))))))))}
        </> 
    );
}

export default Menu;